"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Mobile = _interopRequireDefault(require("@rsuite/icon-font/lib/device/Mobile"));

// Generated by script, don't edit it please.
var Mobile = (0, _createSvgIcon["default"])({
  as: _Mobile["default"],
  ariaLabel: 'mobile',
  category: 'device',
  displayName: 'Mobile'
});
var _default = Mobile;
exports["default"] = _default;
module.exports = exports.default;